import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Pipe({
  name: 'filterStatus'
})
export class FilterStatusPipe implements PipeTransform {
constructor(public appservice: AppService)
{

}
  transform(items: any[], searchText: string): any[] {   if (!items) return [];
   if (!searchText) return items;
    
  searchText = searchText.toLowerCase();
    items = items.filter(it => {
      let invoice_num = it.invoice_num == null ? "" : it.invoice_num;
      let cust_name = it.cust_name == null ? "" : it.cust_name;
      // let prod_order_id = it.prod_order_id == null ? "" : it.prod_order_id;
      let prod_order_id = String(it.prod_order_id);
      return it.order_status_name.toLowerCase().includes(searchText.toLowerCase()) ||
        cust_name.toLowerCase().includes(searchText.toLowerCase()) ||
        invoice_num.toLowerCase().includes(searchText.toLowerCase())||
        prod_order_id.toLowerCase().includes(searchText.toLowerCase());
    });
  
    return items;

  }
 
}


